import { useState, useEffect } from 'react';
import { getAllFunds } from '../../../services/firestoreService';
import Table from '../../shared/UI/Table';
import Badge from '../../shared/UI/Badge';
import Button from '../../shared/UI/Button';

export default function FundList({ onAdd, onEdit, onView }) {
  const [funds, setFunds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAllFunds()
      .then(setFunds)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { key: 'name', label: 'Fund Name' },
    { key: 'short_name', label: 'Short Name' },
    { key: 'base_currency', label: 'Base Currency' },
    {
      key: 'status',
      label: 'Status',
      render: row => <Badge text={row.status} />,
    },
    { key: 'vintage_year', label: 'Vintage Year' },
    {
      key: 'config_version',
      label: 'Version',
      render: row => `v${row.config_version || 1}`,
    },
    {
      key: 'actions',
      label: 'Actions',
      render: row => (
        <div className="flex gap-2">
          <Button size="sm" variant="secondary" onClick={() => onEdit(row)}>Edit</Button>
          <Button size="sm" variant="ghost" onClick={() => onView(row)}>View</Button>
        </div>
      ),
    },
  ];

  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <div className="card">
      <div className="card-header">
        <h2>Funds ({funds.length})</h2>
        <Button variant="primary" onClick={onAdd}>+ Add New Fund</Button>
      </div>
      <Table
        columns={columns}
        data={funds}
        loading={loading}
        emptyTitle="No funds configured yet"
        emptyMessage="Create the first fund to get started."
        emptyAction={{ label: '+ Add New Fund', onClick: onAdd }}
      />
    </div>
  );
}
